import constants from 'constants/index'

const chipStatusLabel = (status) => {
  return (
    (status && constants.settings.FINANCIAL_CHIP_STATUS_LABEL[status]) ||
    'Indefinido'
  )
}

export default chipStatusLabel
